import { doHouseVoteAsync, setDidVote } from "@/store/slices/GlobalSlice";
import React, { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import Slider from "react-slick";
import BtnGreen from "../BtnGreen";

const TownSlider = () => {
  const dispatch = useDispatch();
  const { townSliderImages, modalVisible, didVote } = useSelector(
    (state) => state.globalSlice
  );
  const sliderRef = useRef(null);
  const [isFirstSlide, setIsFirstSlide] = useState(true);
  const [isFinalSlide, setIsFinalSlide] = useState(false);

  useEffect(() => {
    if (modalVisible === false) {
      resetArrows();
    }
  }, [modalVisible]);

  useEffect(() => {
    if (townSliderImages.length === 0 || didVote) {
      // dispatch(setDidVote());
      return;
    }
    sliderRef.current.slickGoTo(0);
  }, [townSliderImages]);

  const resetArrows = () => {
    setIsFirstSlide(true);
    setIsFinalSlide(false);
  };

  const settings = {
    dots: false,
    infinite: false,
    speed: 800,
    adaptiveHeight: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    beforeChange: (current, next) => {
      // show both arrows when middle
      if (next !== 0) {
        setIsFirstSlide(false);
        setIsFinalSlide(false);
      }

      // hide prev arrow when first slide
      if (next == 0) {
        setIsFirstSlide(true);
        setIsFinalSlide(false);
      }

      // hide next arrow when final slide
      if (next == townSliderImages.length - 1) {
        setIsFinalSlide(true);
      }
    },
  };

  const handleShare = (obj) => {
    if (typeof obj == "undefined") return;
    const imgId = obj.id;
    const townId = obj.town.term_id;
    const shareUrl = `https://www.facebook.com/sharer/sharer.php?u=${window.location.origin}/sharer.php?imgDetails=${imgId}|${townId}|${obj.url}`;

    window.open(
      shareUrl,
      "NewWin",
      "toolbar=no,status=no,width=350,height=135"
    );
  };

  const handleVote = (slide) => {
    dispatch(doHouseVoteAsync(slide.id));
  };

  const next = () => {
    sliderRef.current.slickNext();
  };
  const previous = () => {
    sliderRef.current.slickPrev();
  };

  return (
    <div>
      <div className="relative">
        {townSliderImages.length > 0 ? (
          <div>
            <Slider ref={sliderRef} {...settings}>
              {townSliderImages?.map((slide, index) => (
                <React.Fragment key={index}>
                  <figure className="overflow-hidden">
                    <div className="mb-5 relative h-250 md:h-400 flex items-center justify-center">
                      <img
                        className="rounded-3xl mx-auto w-full h-full object-contain object-center"
                        src={slide.url}
                        alt="image"
                      />
                    </div>

                    <div className="flex flex-wrap md:justify-between items-start">
                      <figure className="order-3 md:order-1 text-center md:text-left w-full md:w-auto mb-3 md:mb-0 max-w-md">
                        <h2 className="text-2.5xl text-sgbc-black-800 mb-2">
                          {slide.town.name}
                        </h2>
                        <p className="text-lg">{slide.description}</p>
                      </figure>

                      <figure className="order-1 md:order-2 flex items-center justify-center md:justify-start space-x-4 mb-4 w-full md:w-auto">
                        <figure className="hidden md:inline-flex items-center">
                          <span style={{ width: "27px" }}>
                            <img
                              src={require("@/assets/images/like-green.png")}
                              alt="icon"
                            />
                          </span>

                          <span className="text-lg font-semibold ml-3 text-sgbc-green-500">
                            {slide.total_voted}
                          </span>
                        </figure>

                        <BtnGreen
                          className="space-x-5 text-lg font-semibold cursor-pointer"
                          onClick={() => handleVote(slide)}
                        >
                          <span style={{ width: "27px" }}>
                            <img
                              src={require("@/assets/images/like@2x.png")}
                              alt="icon"
                            />
                          </span>
                          <span>Like</span>
                        </BtnGreen>

                        <BtnGreen
                          className="space-x-5 text-lg font-semibold cursor-pointer"
                          onClick={() => handleShare(slide)}
                        >
                          <span style={{ width: "27px" }}>
                            <img
                              src={require("@/assets/images/share.png")}
                              alt="icon"
                            />
                          </span>
                          <span>Share</span>
                        </BtnGreen>
                      </figure>

                      <figure className="w-full flex md:hidden items-center justify-center order-2 mb-10">
                        <span style={{ width: "27px" }}>
                          <img
                            src={require("@/assets/images/like-green.png")}
                            alt="icon"
                          />
                        </span>

                        <span className="text-lg font-semibold ml-3 text-sgbc-green-500">
                          {slide.total_voted}
                        </span>
                      </figure>
                    </div>
                  </figure>
                </React.Fragment>
              ))}
            </Slider>

            {/* slider arrows */}
            {townSliderImages.length > 1 && (
              <div className="flex justify-between">
                {!isFirstSlide && (
                  <span
                    className="md:absolute md:top-1/2 md:transform md:-translate-y-20 bg-sgbc-green-200 hover:bg-sgbc-green-500 w-50 h-50 flex items-center justify-center cursor-pointer rounded-full transition-all duration-200 ease-in-out"
                    style={{ left: "-65px" }}
                    onClick={previous}
                  >
                    <img
                      src={require("@/assets/images/left-arrow.png")}
                      alt="icon"
                    />
                  </span>
                )}

                {!isFinalSlide && (
                  <span
                    className="md:absolute md:top-1/2 md:transform md:-translate-y-20 bg-sgbc-green-200 hover:bg-sgbc-green-500 w-50 h-50 flex items-center justify-center cursor-pointer rounded-full transition-all duration-200 ease-in-out"
                    style={{ right: "-65px" }}
                    onClick={next}
                  >
                    <img
                      src={require("@/assets/images/right-arrow.png")}
                      alt="icon"
                    />
                  </span>
                )}
              </div>
            )}
          </div>
        ) : (
          <div className="text-xl font-semibold">No Content</div>
        )}
      </div>
    </div>
  );
};

export default TownSlider;
